
import AccountSpecificBottomNav from './AccountSpecificBottomNav';

const MobileBottomNav = () => {
  return <AccountSpecificBottomNav />;
};

export default MobileBottomNav;
